export function mirrorHelpThemeToAfasTheme(
  root: HTMLElement,
): MutationObserver {
  function apply(): void {
    const helpTheme = root.getAttribute("data-theme");
    root.setAttribute("theme", helpTheme === "dark" ? "dark" : "light");
  }

  apply();
  const observer = new MutationObserver(apply);
  observer.observe(root, { attributes: true, attributeFilter: ["data-theme"] });
  return observer;
}
